@use '../../../style/globals.scss' as *;

.NewsTickerItem {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    padding: 10px;
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.49, 0.99, 0.68, 1.1);

    @media (max-width: $bp-xs) {
        padding: 5px;
    }

    .message {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 10px;
        background-color: transparent;
        color: var(--token-arise-theme-1-updates-updates-general-light);
        border-radius: 10px;
        gap: 10px;
        line-height: 18px;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            inset: 0;
            background-color: var(--token-arise-theme-1-updates-updates-general-dark);
            border-radius: inherit;
            pointer-events: none;
        }

        @media (max-width: $bp-xs) {
            padding: 7px;
            font-size: $font-size-small;
            line-height: 15px;
            gap: 7px;
        }

        p {
            z-index: 1;
            display: -webkit-box;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .icon {
            position: relative;
            z-index: 1;
            display: flex;
            flex-shrink: 0;
            justify-content: center;
            align-items: center;
            width: 22px;
            height: 22px;
            background-color: var(--token-arise-theme-1-updates-updates-general-mid);
            border-radius: 50%;

            path {
                fill: var(--token-arise-theme-1-updates-updates-general-light);
            }
        }

        span {
            color: var(--token-accent-theme-1-interface-mono-interface-white);
            font-weight: bold;
        }

        &.general {
            &::before {
                background-color: var(--token-arise-theme-1-updates-updates-general-dark);
            }
            color: var(--token-arise-theme-1-updates-updates-general-light);

            .icon {
                background-color: var(--token-arise-theme-1-updates-updates-general-mid);
                path {
                    fill: var(--token-arise-theme-1-updates-updates-general-light);
                }
            }
        }

        &.positive {
            &::before {
                background-color: var(--token-arise-theme-1-updates-updates-positive-dark);
            }
            color: var(--token-arise-theme-1-updates-updates-positive-light);

            .icon {
                background-color: var(--token-arise-theme-1-updates-updates-positive-mid);
                path {
                    fill: var(--token-arise-theme-1-updates-updates-positive-light);
                }
            }
        }

        &.negative {
            &::before {
                background-color: var(--token-arise-theme-1-updates-updates-negative-dark);
            }
            color: var(--token-arise-theme-1-updates-updates-negative-light);

            .icon {
                background-color: var(--token-arise-theme-1-updates-updates-negative-mid);
                path {
                    fill: var(--token-arise-theme-1-updates-updates-negative-light);
                }
            }
        }

        &.achievement,
        &.notification {
            &::before {
                background-color: var(--token-arise-theme-1-updates-updates-achievement-dark);
            }
            color: var(--token-arise-theme-1-updates-updates-achievement-light);

            .icon {
                background-color: var(--token-arise-theme-1-updates-updates-achievement-mid);
                path {
                    fill: var(--token-arise-theme-1-updates-updates-achievement-light);
                }
            }
        }
    }

    &.hasLowerTransparency {
        .message::before {
            opacity: 0.2;
        }
    }
}
